<template>
  <div class="submission-tabs-container">
    <ul
      class="row tabs hkld-tabs"
      data-tabs
      :id="id"
    >
      <li
        class="tabs-title column"
        :class="{ 'is-active': index === 0}"
        v-for="(tabName, index) in tabNames"
        :key="index"
      >
        <a
          v-checkVisibility
          :href="`#comment-tab-${index}`"
          @click="autoResize"
          :style="extendStyleA"
        >{{ tabName }}</a>
      </li>
    </ul>

    <div
      class="hkld-tabs-content"
      :data-tabs-content="id"
    >
      <div
        class="tabs-panel is-active"
        id="comment-tab-0"
        :style="extendStyleContent"
      >
        <div class="clearfix">
          <slot name="tab-0" />
        </div>
      </div>
      <div
        class="tabs-panel"
        id="comment-tab-1"
        :style="extendStyleContent"
      >
        <div class="clearfix">
          <slot name="tab-1" />
        </div>
      </div>
      <div
        class="tabs-panel"
        id="comment-tab-2"
        :style="extendStyleContent"
      >
        <div class="clearfix">
          <slot name="tab-2" />
        </div>
      </div>
      <div
        class="tabs-panel"
        id="comment-tab-3"
        :style="extendStyleContent"
      >
        <div class="clearfix">
          <slot name="tab-3" />
        </div>
      </div>
      <div
        class="tabs-panel"
        id="comment-tab-4"
        :style="extendStyleContent"
      >
        <div class="clearfix">
          <slot name="tab-4" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { utils as formUtils } from '@/plugin/InputChange'

export default {
  name: 'SubmissionTabsContainer',
  props: {
    tabNames: {
      type: Array,
      required: true,
    },
    isMoreTabs: {
      type: Boolean,
      default: false,
    },
    getCurrentTab: {
      type: Function,
      default: () => {},
    },
    extendStyleTabs: {
      type: Object,
      default: () => {},
    },
    extendStyleA: {
      type: Object,
      default: () => {},
    },
    extendStyleContent: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      id: `submission-tab-container-${new Date().getTime()}-${Math.floor(Math.random() * 1000)}`,
    }
  },
  methods: {
    autoResize () {
      $(document.activeElement).blur()
      setTimeout(formUtils.resizeElements, 0)
    },
    rebuildTabContainers () {
      if (this.submissionCommonTabs && Object.keys(this.submissionCommonTabs).length > 0) {
        if ($(`#${this.id}`).childElementCount > 0) {
          this.submissionCommonTabs.destroy()
        }
        delete this.submissionCommonTabs
      }
      if (!this.submissionCommonTabs) {
        this.submissionCommonTabs = new Foundation.Tabs($(`#${this.id}`))
      }
      this.clickFirstTab()
    },
    clickFirstTab () {
      const firstTab = $(`#${this.id} li a`)[0]
      if (firstTab) {
        firstTab.click()
      }
    },
  },
  mounted () {
    if (!this.submissionCommonTabs) {
      this.submissionCommonTabs = new Foundation.Tabs($(`#${this.id}`))
    }
    this.clickFirstTab()

    this.$on(`refresh-containers-${this.id}`, this.rebuildTabContainers)
  },
  watch: {
    tabNames () {
      /**
       * Cause:
       * If tabNames value changes (especially if the length of tabNames change),
       * the foundation tab component will not be rebuilt and conflict with the
       * tab-contents. (Issue HKLDCMS-16376)
       * PS: When tabNames was changing, the VUE hasn't redenered the tab-title (<li>). * Meanwhile, the rebuild function has been executed. So the rebuilding is failed
       *
       * Solution:
       * Rebuild the foundation tab component when tabNames changes.
       * Use $nextTick to make sure the rebuilding after the DOM has been rendered
       */
      this.$nextTick(() => {
        this.$emit(`refresh-containers-${this.id}`)
      })
    },
  },
  destroyed () {
    this.$off(`refresh-containers-${this.id}`)
    if (this.submissionCommonTabs) {
      this.submissionCommonTabs.destroy()
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/settings';

#tabs-nav {
  display: flex;
  min-width: 660px;
  overflow: auto;
}

#sticky-tabs {
  background: $tender-dark-grey;
}

#tabs-nav a {
  background: none;
}

.tabs-panel {
  background: $white;
  padding: 0;
}

.errorTab {
  background-color: $error-light-red!important;
}

.tabs {
  border: none;
  overflow: visible;
}

.hkld-tabs-content {
  background-color: $white;
  box-shadow: 0 1px 5px rgba(128, 128, 128, 0.2);
}

.hkld-tabs>.column {
  padding: 0;
}

.tabs-title {
  overflow: hidden;
  height: 48px;
  min-height: 48px;
  line-height: 48px;
  padding-left: 15px;
  font-weight: bold;
  color: #0C3A58;
  padding: 0 10px;
  box-shadow: 0 1px 5px rgba(128, 128, 128, 0.2);
}

.tabs-title.is-active>a {
  background-color: $white!important;
  border-bottom: 5px solid $tender-font-color;
  margin-top: 0px!important;
  color: $tender-font-color!important;
}

.sticky-tabs-nav>.is-active-tab {
  background-color: $tender-font-color!important;
  color: $white!important;
}

.tabs-title>a {
  height: 100%;
  background-color: $white;
  font-size: 14px;
  text-align: center;
  color: $tender-font-color!important;
  text-transform: none;
  border-bottom: 5px solid $white;
}

.tabs-title.sticky-tabs-nav>a {
  margin-top: 0;
}
</style>
